export const truncate = (input, size) => {
  return (
    input && input.length > size ? `${input.substr(0, size)}...` : input
  );
};
